<template>
  <v-footer height="auto" color="#195d6f" class="hvh-footer py-3">
    <a :href="hvhUrl" class="hvh-footer__logo">
      <img src="/fixed-hvh/img/logo_actics.svg" alt="ACTICS logo BY EVERSANA" />
    </a>
    <ul class="hvh-footer__nav d-flex pl-3">
      <li class="mx-2" v-for="item in navItems" :key="item.url">
        <a :href="item.url">{{ item.title }}</a>
      </li>
    </ul>
    <v-spacer></v-spacer>
    <slot></slot>
  </v-footer>
</template>

<script  >
export default {
  props: ['hvhUrl', 'navItems'],
};
</script>

<style lang="scss">
.theme--light.hvh-footer {
  color: $color-white;
  padding: 0 rem(20px);
  font-size: rem(12px);
}

.hvh-footer__logo {
  width: rem(90px);

  img {
    display: block;
    width: 100%;
  }
}

.hvh-footer__nav {
  list-style: none;

  a {
    color: $color-white;
    font-weight: 700;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>


